import Plan from "@mapmycustomers/shared/types/Plan";

import SubscriptionPlan from "@app/enum/SubscriptionPlan";

import getCurrentSubscriptionPlan from "./getCurrentSubscriptionPlan";

// A real, sellable licence tier. It also drops every (Legacy) row, which carries metaData: null.
export const isSellableTier = ({ metaData, name, planType }: Plan) =>
  !!metaData && planType === "license" && !name.toLowerCase().includes("legacy");

// Only a plan backed by a real Stripe Price can be bought in-app. A white-glove plan has nothing
// to charge against, so its stripeId is a hand-typed slug rather than a price id.
export const isPurchasableTier = (plan: Plan) =>
  isSellableTier(plan) && plan.stripeId.startsWith("price_");

// One matcher for both directions. A row whose name matches two tiers belongs to the more
// expensive one, so the order is Field Intelligence, then Enterprise, then Industry Leader.
const findPlanTier = (plans: Plan[], subscriptionPlan: SubscriptionPlan): Plan | undefined =>
  plans
    .filter(isSellableTier)
    .find((plan) => getCurrentSubscriptionPlan(plan.name) === subscriptionPlan);

export default findPlanTier;
